type Props = {
  fill: string;
  width?: number;
  height?: number;
};
function RestDayIconSvg(props: Props) {
  const { fill, width = 16, height = 16 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_1189_2590)">
        <path d="M9 0H7V2H9V0Z" fill={fill} />
        <path
          d="M14.2927 3.05152L12.8789 1.63672L11.4641 3.05052L12.8779 4.46532L14.2927 3.05152Z"
          fill={fill}
        />
        <path d="M16 7H14V9H16V7Z" fill={fill} />
        <path
          d="M11.5344 13.0198L12.9492 14.4336L14.363 13.0188L12.9482 11.605L11.5344 13.0198Z"
          fill={fill}
        />
        <path d="M9 14H7V16H9V14Z" fill={fill} />
        <path
          d="M1.56667 12.9485L2.98047 14.3633L4.39527 12.9495L2.98147 11.5347L1.56667 12.9485Z"
          fill={fill}
        />
        <path d="M2 7H0V9H2V7Z" fill={fill} />
        <path
          d="M4.46558 3.12083L3.05078 1.70703L1.63698 3.12183L3.05178 4.53563L4.46558 3.12083Z"
          fill={fill}
        />
        <path
          d="M8 4C5.8 4 4 5.8 4 8C4 10.2 5.8 12 8 12C10.2 12 12 10.2 12 8C12 5.8 10.2 4 8 4Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default RestDayIconSvg;
